import { useState, useEffect } from 'react'

import axios from 'axios'

import { clearDccBridgeFirstUse } from 'Pods/ThreeDStudio/Services/dccBridgeFirstUse'

// A generated-model page (/ai/3d-models/:slug, optionally locale-prefixed) is
// owner/private-gated, so reloading it as a guest renders the 404/forbidden
// page. Capture group 1 is the locale prefix (if any) so we can keep it.
const AI_RUN_DETAIL_PATH = /^(\/[a-z]{2}(?:-[a-z]{2})?)?\/ai\/3d-models\/.+/i

// ConferenceSignInModal stashes the live event name in localStorage when it strips
// the conference URL param after sign-in. On logout from the booth tablet we pop it
// back into the URL so the next visitor lands on the conference modal again.
function postLogoutTarget() {
  try {
    const raw = localStorage.getItem('conferenceEvent')
    localStorage.removeItem('conferenceEvent')
    const parsed = raw ? JSON.parse(raw) : null
    if (parsed?.event && parsed?.expiresAt > Date.now()) {
      return `/ai?conference=${encodeURIComponent(parsed.event)}`
    }
  } catch (_) { /* malformed or disabled — fall back */ }

  // Logging out on a model page would bounce the now-guest back to a gated URL;
  // send them to the studio home (keeping any locale prefix) instead.
  const runDetailMatch = window.location.pathname.match(AI_RUN_DETAIL_PATH)
  if (runDetailMatch) {
    return `${runDetailMatch[1] || ''}/ai`
  }

  return window.location.pathname + window.location.search
}

function useUserData(isSignedIn) {
  const [userData, setUserData] = useState({})

  useEffect(() => {
    if (isSignedIn) {
      fetchUserData()
    }
  }, [isSignedIn])

  function handleLogout() {
    if (isSignedIn) {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

      clearDccBridgeFirstUse()

      return axios
        .delete('/users/logout', {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        })
        .then(() => {
          window.location.assign(postLogoutTarget())
        })
        .catch()
    }

    return null
  }

  function fetchUserData() {
    return axios
      .get('/api/internal/users/me')
      .then(response => {
        setUserData(response.data.data)
      })
      .catch()
  }

  return {
    userData,
    handleLogout,
  }
}

export { useUserData }
